import { render, staticRenderFns } from "./product_advanced.vue?vue&type=template&id=8740dcaa&scoped=true&"
import script from "./product_advanced.vue?vue&type=script&lang=js&"
export * from "./product_advanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8740dcaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8740dcaa')) {
      api.createRecord('8740dcaa', component.options)
    } else {
      api.reload('8740dcaa', component.options)
    }
    module.hot.accept("./product_advanced.vue?vue&type=template&id=8740dcaa&scoped=true&", function () {
      api.rerender('8740dcaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_advanced.vue"
export default component.exports